import { useState, useEffect, useContext } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Alert,
  Modal,
  ProgressBar,
  Card,
  Nav,
  Table,
} from "react-bootstrap";

import _ from "lodash";
import axios from "axios";
import moment from "moment";
import Utils from "../../common/Utils";
import { UserContext } from "../../common";

import DropdownMenu from "./../cqc/DropdownMenu";

const Userprofile = (props) => {
  const { userData } = useContext(UserContext);
  // console.log(userData.uid)

  const [data, setData] = useState({});
  const [udocs, setUDocs] = useState({
    doctypes: [],
    userdocs: [],
    userdocfiles: [],
    counts: [],
    udgs: [],
  });
  const [loading, setLoading] = useState(true);
  const [dtype, setDType] = useState(parseInt(_.get(props, "cat", 0)));
  const [resources, setResources] = useState(false);
  const [upload, setUpload] = useState(false);
  const [trail, setTrail] = useState(false);
  const [sall, setsall] = useState(props.status);
  const [gapStatus, setGapStatus] = useState(props.gapStatus);
  const [udNote, showUDNote] = useState(false);
  const [notes, setNotes] = useState([]);
  const [saveNote, setSaveNote] = useState(false);

  const [msg, setMsg] = useState(false);
  const [loadres, setLoadres] = useState(false);
  var onetimestatus = props.status !== undefined ? props.status : 0;

  const profileDetails = (status = onetimestatus ? onetimestatus : 0) => {
    setLoading(true);

    onetimestatus = 0;
    // status===0 ? setShowprof(true) : setShowprof(false);
    axios
      .get(
        Utils.apiUrl(`users/fetchprofile/${props.data.id}`) +
          "?show=1&status=" +
          status,
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data.success) {
          setData(_.get(res, "data.profile", []));
          setUDocs({
            doctypes: _.get(res, "data.doctypes", []),
            userdocs: _.get(res, "data.userdocs", []),
            userdocfiles: _.get(res, "data.userdocfiles", []),
            counts: _.get(res, "data.counts", []),
            udgs: _.get(res, "data.udgs", []),
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  };

  useEffect(profileDetails, []);

  const renderProfile = () => {
    return (
      <div className="p-4" style={{ backgroundColor: "#CEDDEF88" }}>
        <h4 className="mb-4">
          <b>
            {_.get(data, "title", "")} {_.get(data, "firstname", "")}{" "}
            {_.get(data, "middlename", "")} {_.get(data, "lastname", "")}
          </b>
        </h4>
        <Row>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-3">
            <h6>
              <b>Personal Details</b>
            </h6>
            <div>
              <b>Phone Number: </b>
              {_.get(data, "phone", " - ")}
            </div>
            <div>
              <b>Email ID: </b>
              {_.get(data, "email", " - ")}
            </div>
            <div>
              <b>GDC Number: </b>
              {_.get(data, "profile.gdc", " - ")}
            </div>

            <div>
              <b>Designation: </b>
              {_.get(data, "designation", " - ")}
            </div>
            <div>
              <b>Gender: </b>
              {_.get(data, "profile.gender", " - ")}
            </div>
          </Col>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-3">
            <h6>
              <b>Other Details</b>
            </h6>
            <div>
              <b>Date of Birth: </b>
              {_.get(data, "profile.dob", " - ")}
            </div>
            <div>
              <b>Employment Start Date: </b>
              {_.get(data, "profile.doj", " - ")}
            </div>
            <div>
              <b>Employment Finish Date: </b>
              {_.get(data, "profile.lwd", " - ")}
            </div>
            <div>
              <b>Pronouns: </b>
              {_.get(data, "profile.pronoun", " - ")}
            </div>
          </Col>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-3">
            <h6>
              <b>Bank Account Details</b>
            </h6>
            <div>
              <b>A/C Number: </b>
              {_.get(data, "profile.acnum", " - ")}
            </div>
            <div>
              <b>SORT/IFSC Code: </b>
              {_.get(data, "profile.ifsc", " - ")}
            </div>
            <div>
              <b>Bank Name: </b>
              {_.get(data, "profile.bank", " - ")}
            </div>
            <div>
              <b>Branch: </b>
              {_.get(data, "profile.branch", " - ")}
            </div>
          </Col>
        </Row>
        <div className="mb-3">
          <b>Notes:</b>{" "}
          <div
            style={{
              backgroundColor: "#fff",
              padding: "3px",
              wordBreak: "break-word",
            }}
            dangerouslySetInnerHTML={{
              __html: _.get(data, "profile.notes", " - "),
            }}
          ></div>
        </div>
        <Row>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-3">
            <h6>
              <b>1st Emergency Contact</b>
            </h6>
            <div>
              <b>Relationship: </b>
              {_.get(data, "profile.relship1", " - ")}
            </div>
            <div>
              <b>Name: </b>
              {_.get(data, "profile.name1", " - ")}
            </div>
            <div>
              <b>Address:</b>
              {_.get(data, "profile.address1", " - ")}
            </div>
            <div>
              <b>Phone:</b>
              {_.get(data, "profile.phone1", " - ")}
            </div>
          </Col>

          <Col sz={4} xl={4} lg={4} md={4} className="mb-3">
            <h6>
              <b>2nd Emergency Contact</b>
            </h6>
            <div>
              <b>Relationship: </b>
              {_.get(data, "profile.relship2", " - ")}
            </div>
            <div>
              <b>Name: </b>
              {_.get(data, "profile.name2", " - ")}
            </div>
            <div>
              <b>Address: </b>
              {_.get(data, "profile.address2", " - ")}
            </div>
            <div>
              <b>Phone: </b>
              {_.get(data, "profile.phone2", " - ")}
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const docSummery = () => {
    return (
      <Row>
        <Col>
          <Card border="light" className="shadow dashboardStats">
            <Card.Body>
              <Row>
                <Col xs="6" sm="6" md="6" lg="3">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Approved Documents"
                    onClick={() => {
                      profileDetails(1);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "green",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.get(udocs, "counts[0].app_count", 0)}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-4 subtitle">Approved</span>{" "}
                        <span className="d-block mb-2 subtitle">Documents</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="6" lg="3">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Pending Documents"
                    onClick={() => {
                      profileDetails(2);
                      setsall(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      {/* <span className="title me-2" style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '50px',
                        height: '50px',
                        color:'white',
                        backgroundColor: '#ffbf00 ',
                        borderRadius: '8px',
                      }}>
                        {_.get(udocs,'counts[0].pend_count',0)}
                      </span> */}
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#ffbf00 ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.get(udocs, "counts[0].pend_count", 0)}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-4 subtitle">Pending</span>
                        <span className="d-block mb-2 subtitle">Documents</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="6" lg="3" mt="5">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Disapproved Documents"
                    onClick={() => {
                      profileDetails(3);
                      setsall(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      {/* <span className="title me-2" style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '50px',
                        height: '50px',
                        color:'white',
                        backgroundColor: 'maroon',
                        borderRadius: '8px',
                      }}>
                        {_.get(udocs,'counts[0].disapp_count',0)}
                      </span> */}
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "maroon ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.get(udocs, "counts[0].disapp_count", 0)}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-4 subtitle">
                          Disapproved
                        </span>
                        <span className="d-block mb-2 subtitle">Documents</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="6" lg="3">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Expired Documents"
                    onClick={() => {
                      profileDetails(4);
                      setsall(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "red ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.get(udocs, "counts[0].expire_count", 0)}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-4 subtitle">Expired</span>
                        <span className="d-block mb-2 subtitle">Documents</span>
                      </span>
                    </span>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
  };

  const docGapSummary = () => {
    return (
      <Row className="mt-3">
        <Col>
          <Card border="light" className="shadow dashboardStats">
            <Card.Body>
              <Row>
                <Col xs="6" sm="6" md="4" lg="2">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all documents"
                    onClick={() => {
                      setGapStatus(0);
                      setDType(0);
                      setsall(0);
                      profileDetails(null);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#070D59",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.get(udocs.counts, "[0].total", 0)}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">Total</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="4" lg="2">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Have this document"
                    onClick={() => {
                      setGapStatus(1);
                      setDType(0);
                      setsall(0);
                      profileDetails(null);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#76D773",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.size(
                            _.filter(udocs.udgs, (gs) => gs.gap_status == 1),
                          )}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">Have This</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="4" lg="3" mt="5">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Working on it"
                    onClick={() => {
                      setGapStatus(2);
                      setDType(0);
                      setsall(0);
                      profileDetails(null);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#FFBF00 ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.size(
                            _.filter(udocs.udgs, (gs) => gs.gap_status == 2),
                          )}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">
                          Working on it
                        </span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="4" lg="3">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Don't Have"
                    onClick={() => {
                      setGapStatus(3);
                      setDType(0);
                      setsall(0);
                      profileDetails(null);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#EC5353 ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.size(
                            _.filter(udocs.udgs, (gs) => gs.gap_status == 3),
                          )}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">
                          Don't Have
                        </span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="4" lg="2">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all N/A"
                    onClick={() => {
                      setGapStatus(4);
                      setDType(0);
                      setsall(0);
                      profileDetails(null);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#848484 ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.size(
                            _.filter(udocs.udgs, (gs) => gs.gap_status == 4),
                          )}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">N/A</span>
                      </span>
                    </span>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
  };

  const showResources = () => {
    return (
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => setResources(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Resources
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {_.get(resources.files, "length", 0) > 0 && <h3>Documents</h3>}
          <ol>
            {_.map(resources.files, (r) => (
              <li key={r} className="py-1">
                {/* <a href={Utils.apiUrl("users/downloadud") + "/" + r}> */}
                <a
                  target="_blank"
                  href={Utils.viewerLink(r, `users/downloadud/${r}`)}
                >
                  {r}
                </a>
                {/* {r}
                </a> */}
              </li>
            ))}
          </ol>
          {_.get(resources.links, "length", 0) > 0 && <h3>Links</h3>}
          <ol>
            {_.map(resources.links, (r) => (
              <li key={r} className="py-1">
                <a href={r} target="_blank">
                  {r}
                </a>
              </li>
            ))}
          </ol>
        </Modal.Body>
      </Modal>
    );
  };

  const getColor = (doc) => {
    const filteredData = udocs.userdocfiles.filter(
      (item) => item.udid === doc.id,
    );
    if (filteredData.length === 0) {
      return "#070d59";
    }
    // Find max id for latest doc
    const maxId = Math.max(...filteredData.map((item) => parseInt(item.id)));
    // Filter data with max id to get last uploaded doc data
    const lastDoc = filteredData.filter(
      (item) => parseInt(item.id) === maxId,
    )[0];
    // console.log(lastDoc);

    // const lastDoc = filteredData[filteredData.length - 1];
    if (lastDoc.exp_status == "1") {
      return "red";
    }
    if (lastDoc.doc_status == "3") {
      return "maroon";
    }
    if (
      filteredData.some((doc) => doc.doc_status == "2" && doc.exp_status == "0")
    ) {
      return "#FFBF00";
    }
    return "green";
  };

  const changestatus = (id, status, msg = "") => {
    var postvars = `&id=${id}&status=${status}&time=${new moment().format("YYYY-MM-DD HH:mm:ss")}&msg=${msg}`;
    axios
      .post(Utils.apiUrl(`users/changeudfstatus`), postvars, Utils.apiHeaders())
      .then((res) => {
        setLoadres(false);
        if (res.data.success) {
          setUDocs((prevUdocs) => {
            return {
              ...prevUdocs,
              userdocfiles: prevUdocs.userdocfiles.map((userdocfile) => {
                if (userdocfile.id === id) {
                  // Update the userdocfile with the matching ID
                  return { ...userdocfile, ...res.data.udf };
                }
                return userdocfile;
              }),
            };
          });
          setMsg(false);
          // window.alert(res.data.message);
        } else {
          window.alert(
            _.isObject(res.data.message)
              ? Object.values(res.data.message).join(",")
              : res.data.message,
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const uploadFile = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    setLoadres(parseInt(frm.udid.value));

    let formData = new FormData(frm);
    formData.append("time", new moment().format("YYYY-MM-DD HH:mm:ss"));

    axios
      .post(Utils.apiUrl("users/uploadudf"), formData, Utils.apiHeaders())
      .then((res) => {
        setLoadres(false);
        if (res.data.success) {
          setUDocs({
            ...udocs,
            userdocfiles: [...udocs.userdocfiles, res.data.udf],
          });
          frm.reset();
          // window.alert(res.data.message);
        } else {
          window.alert(
            _.isObject(res.data.message)
              ? Object.values(res.data.message).join(",")
              : res.data.message,
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const showUpload = () => {
    let udf = _.filter(
      udocs.userdocfiles,
      (udfs) => parseInt(udfs.udid) === parseInt(upload),
    );
    let ud = _.filter(
      udocs.userdocs,
      (uds) => parseInt(uds.id) === parseInt(upload),
    );
    let settings = JSON.parse(ud[0].settings);

    // let expired = moment().isAfter(udf[0].updated_at, "year");

    return (
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => setUpload(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {ud[0].title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table responsive={true}>
            <thead>
              <tr>
                <td style={{ maxWidth: "150px" }}>Document Name</td>
                <td>Status</td>
                <td>Upload On</td>
                <td>Status(Update On)</td>
                <td>Expire On</td>
                <td>
                  <img src="images/download.png" />
                </td>
                {/* <td>Delete</td> */}
              </tr>
            </thead>
            <tbody>
              {_.map(udf, (r) => (
                <tr>
                  <td>{r.udoc}</td>
                  <td>{showStatus(r, "manage")}</td>
                  <td>{r.created_at}</td>
                  <td>{r.updated_at}</td>
                  <td>{r.expire_on}</td>
                  <td>
                    {/* <a href={Utils.apiUrl("users/downloadudf") + "/" + r.furl}> */}
                    <a
                      target="_blank"
                      href={Utils.viewerLink(
                        r.udoc,
                        `users/downloadudf/${r.furl}`,
                      )}
                    >
                      <img src="images/download.png" />
                    </a>
                  </td>
                  {/* <td>
                    <Button variant="primary" className="ms-2 clickable" size="xs" title="Delete file" onClick={() => deleteudf(r)}>
                      X
                    </Button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </Table>
          {_.get(userData, "is_super_user", false) && (
            <Form onSubmit={uploadFile}>
              <input type="hidden" name="uid" value={_.get(data, "id", 0)} />
              <input type="hidden" name="udid" value={upload} />
              <div className="row mt-5 d-flex align-items-end">
                <div className="col-md-4">
                  <input type="file" required name="udoc" />
                </div>
                {settings.flag == 3 && (
                  <div className="col-md-4">
                    Expire Date (Including no expiry date ensures the file will
                    never expire)
                    <input
                      type="date"
                      name="exp_date"
                      maxlength="255"
                      className="form-control"
                      min={
                        new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
                          .toISOString()
                          .split("T")[0]
                      }
                      format="dd/mm/yyyy"
                      onKeyDown={(e) => e.preventDefault()}
                      placeholder="Expire Date"
                    />
                  </div>
                )}
                <div className="col-md-3">
                  <Button variant="primary" type="submit">
                    Upload
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    );
  };

  const showMsg = () => {
    return (
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => setMsg(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Disapproved
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              changestatus(msg.id, msg.status, e.currentTarget.msg.value);
            }}
          >
            <div className="row  d-flex align-items-end">
              <div className="col-sm-8 mb-2">
                <label htmlFor="msg">Reason for Disapproval</label>
                {/* <input type="text" name="msg" id="msg" /> */}
                <textarea name="msg" id="msg" cols="60" rows="5" />
              </div>
            </div>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    );
  };

  const showStatus = (data, opt) => {
    if (data.exp_status == 0) {
      if (data.doc_status == 1) {
        return <span className="text-success">Approved</span>;
      } else if (data.doc_status == 2) {
        if (opt == "trail" || data.user_id == userData.uid) {
          return <span className="text-warning">Pending</span>;
        } else {
          return (
            <div>
              <Button
                type="button"
                className="m-1 mt-0"
                variant="success"
                onClick={() => changestatus(data.id, 1)}
              >
                Approved
              </Button>
              <Button
                type="button"
                className="m-1 mt-0"
                variant="danger"
                onClick={() => setMsg({ id: data.id, status: 3 })}
              >
                Disapproved
              </Button>
            </div>
          );
        }
      } else if (data.doc_status == 3) {
        return (
          <span className="text-danger" title={data.msg ?? ""}>
            Disapproved {data.msg && <i class="bi bi-chat-left-dots"></i>}
          </span>
        );
      }
    } else {
      return <span className="text-danger">Expired</span>;
    }
  };

  const showTrail = () => {
    let udf = _.filter(
      udocs.userdocfiles,
      (udfs) => parseInt(udfs.udid) === parseInt(trail),
    );
    let ud = _.filter(
      udocs.userdocs,
      (uds) => parseInt(uds.id) === parseInt(trail),
    );

    return (
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => setTrail(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {ud[0].title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h3>Documents</h3> */}

          <Table responsive={true}>
            <thead>
              <tr>
                <td>Name</td>
                <td>Upload On</td>
                <td>Status</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {_.map(udf, (r) => (
                <tr>
                  <td>{r.udoc}</td>
                  <td>{r.created_at}</td>
                  <td>{showStatus(r, "trail")}</td>
                  {/* <td><a href={Utils.apiUrl("users/downloadudf") + "/" + r.furl}><img src="images/download.png"/></a></td> */}
                  <td>
                    <a
                      target="_blank"
                      href={Utils.viewerLink(
                        r.udoc,
                        `users/downloadudf/${r.furl}`,
                      )}
                    >
                      <img src="images/download.png" />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    );
  };

  const renderDocTypes = () => {
    return (
      <div className="mt-4">
        <div className="d-flex justify-content-between">
          <div className="float-left">
            <Nav
              variant="pills"
              className="px-2"
              activeKey={dtype}
              onSelect={setDType}
            >
              <Nav.Item>
                <Nav.Link eventKey={0}>All</Nav.Link>
              </Nav.Item>
              {_.map(udocs.doctypes, (cat, catidx) => (
                <Nav.Item>
                  <Nav.Link eventKey={catidx}>{cat}</Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
          <div className="float-right">
            <Nav
              variant="pills"
              className="px-2"
              activeKey={gapStatus}
              onSelect={setGapStatus}
            >
              {renderGapStatusFilters()}
            </Nav>
          </div>
        </div>
        <Card style={{ backgroundColor: "#CEDDEF88" }}>
          <Card.Body className="m-2">
            <Table responsive={true}>
              <thead>
                <tr>
                  <th className="text-end" width="50">
                    ##
                  </th>
                  <th>Document Title</th>
                  {parseInt(dtype) === 0 && <th>Category</th>}
                  <th>Resources</th>
                  <th>Action</th>
                  <th></th>
                  <th>Gap Analysis</th>
                  <th>
                    <img src={`${process.env.PUBLIC_URL}/images/notes-d.png`} />
                  </th>
                </tr>
              </thead>
              <tbody>{renderUDF()}</tbody>
            </Table>
          </Card.Body>
        </Card>
      </div>
    );
  };

  const renderGapStatusFilters = () => {
    let uds = udocs.userdocs;
    if (dtype > 0) {
      uds = _.filter(uds, (p) => parseInt(p.cat) === parseInt(dtype));
    }

    return (
      <>
        {_.map(_.slice(Utils.getGapStatusList(), 1), (gs) => {
          let udgscol = _.filter(
            udocs.udgs,
            (udg) => parseInt(udg.gap_status) === parseInt(gs[0]),
          );
          udgscol = _.filter(uds, (ud) =>
            _.includes(
              _.map(udgscol, (u) => u.udid),
              ud.id,
            ),
          );
          return (
            <Nav.Item className="me-0">
              <Nav.Link
                style={{ backgroundColor: gs[3], "border-radius": 0 }}
                className="text-white"
                eventKey={gs[0]}
              >
                {_.size(udgscol)}/{uds.length}
              </Nav.Link>
            </Nav.Item>
          );
        })}
      </>
    );
  };

  const renderUDF = () => {
    let uds = udocs.userdocs;
    if (dtype != 0) {
      uds = _.filter(
        udocs.userdocs,
        (p) => parseInt(p.cat) === parseInt(dtype),
      );
    }

    if (parseInt(sall) === 5 || parseInt(sall) !== 0) {
      uds = _.filter(
        uds,
        (p) =>
          (parseInt(sall) === 5 && getColor(p) == "#070d59") ||
          (parseInt(sall) !== 0 &&
            parseInt(sall) !== 5 &&
            getColor(p) != "#070d59"),
      );
    }

    if (gapStatus > 0) {
      uds = _.filter(uds, (u) =>
        _.includes(
          _.map(
            _.filter(udocs.udgs, (g) => g.gap_status == gapStatus),
            (g) => g.udid,
          ),
          u.id,
        ),
      );
    }

    if (uds.length > 0) {
      return _.map(uds, (ud, idx) => {
        return (
          <tr>
            <td className="text-end">
              <div className="badge bg-primary text-white">
                {Utils.addZero(idx + 1)}
              </div>
            </td>
            <td>{ud.title}</td>
            {parseInt(dtype) === 0 && <td>{udocs.doctypes[ud.cat]}</td>}
            <td>
              <Button
                type="button"
                variant="primary"
                onClick={() => setResources(JSON.parse(ud.resources))}
                disabled={ud.length === 0}
              >
                View
              </Button>
            </td>

            <td>
              <Button
                className="me-2 ms2"
                type="button"
                variant="contained"
                style={{ backgroundColor: getColor(ud), color: "white" }}
                onClick={() => setUpload(ud.id)}
              >
                {getColor(ud) == "#070d59" ? "Upload" : "Manage"}
              </Button>
            </td>
            <td>
              <Button
                className="me-2 ms2 "
                type="button"
                variant="primary"
                onClick={() => setTrail(ud.id)}
                disabled={ud.length === 0}
              >
                Trail
              </Button>
            </td>
            <td>
              <DropdownMenu
                key={ud.id}
                doc={{
                  id: ud.id,
                  gap_status: _.get(
                    _.find(udocs.udgs, (gs) => gs.udid == ud.id),
                    "gap_status",
                    0,
                  ),
                }}
                changestatus={changeGapStatus}
              />
            </td>
            <td>
              <img
                src={`${process.env.PUBLIC_URL}/images/notes.png`}
                className="clickable"
                title={`Notes for ${ud.title}`}
                onClick={() => showUDNote(ud)}
              />
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colspan={parseInt(dtype) === 0 ? 7 : 6}>
            <Alert variant="warning">
              No documents uploaded in this section!
            </Alert>
          </td>
        </tr>
      );
    }
  };

  const changeGapStatus = (udid, gs) => {
    const postdata = `&uid=${props.data.id}&udid=${udid}&status=${gs}`;
    //setLoading(true);
    axios
      .post(Utils.apiUrl(`users/savegapstatus`), postdata, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setUDocs({
            ...udocs,
            udgs: _.get(res, "data.udgs", []),
          });
        }
        //setLoading(false);
      })
      .catch((err) => {
        //setLoading(true);
        console.log(err);
      });
  };

  const fetchUDNotes = () => {
    if (udNote !== false && _.isUndefined(udNote.loading)) {
      showUDNote({ ...udNote, loading: true });
      axios
        .get(
          Utils.apiUrl(
            `users/fetchnotes?uid=${props.data.id}&udid=${udNote.id}`,
          ),
          Utils.apiHeaders(),
        )
        .then((res) => {
          showUDNote({ ...udNote, loading: false });
          if (res.data.success) {
            setNotes(res.data.data);
          } else {
            window.alert(res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(fetchUDNotes, [udNote]);

  const saveUDNote = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    const formData = new FormData(frm);
    if (_.isEmpty(frm.note.value)) {
      window.alert("Please fill notes to save");
      return false;
    }
    formData.append("uddoc_id", udNote.id);
    formData.append("user_id", props.data.id);
    setSaveNote(true);
    axios
      .post(Utils.apiUrl(`users/savenote`), formData, Utils.apiHeaders())
      .then((res) => {
        setSaveNote(false);
        showUDNote(_.omit(udNote, ["notes", "loading"]));
      })
      .catch((err) => console.log(err));
  };

  const deleteNote = (nid) => {
    if (window.confirm("You are going to delete this note, continue?")) {
      setNotes(_.filter(notes, (n) => n.id !== nid));
      axios
        .delete(Utils.apiUrl(`users/delnote/${nid}`), Utils.apiHeaders())
        .catch((err) => console.log(err));
    }
  };

  const showNotesForUD = () => {
    return (
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => showUDNote(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Notes - {udNote.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {saveNote === true && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">Saving User Document Note..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}
          {saveNote === false && (
            <>
              <Form onSubmit={saveUDNote}>
                <div className="d-flex">
                  <textarea
                    name="note"
                    required
                    className="form-control me-2"
                    rows={2}
                    placeholder="Enter your Note"
                  ></textarea>
                  <div className="ms-2">
                    <Button type="submit" variant="dark">
                      Submit
                    </Button>
                  </div>
                </div>
              </Form>
            </>
          )}
          {udNote.loading === true && (
            <Alert variant="warning" className="p-3">
              <p className="loading-msg">Fetching User Document Note..</p>
              <ProgressBar variant="warning" animated now={100} />
            </Alert>
          )}
          {udNote.loading === false && (
            <div style={{ maxHeight: "400px", overflow: "auto" }}>
              {_.get(notes, "length", 0) === 0 && (
                <Alert variant="danger" className="p-3">
                  <p className="loading-msg">No comments found!</p>
                </Alert>
              )}
              {_.map(notes, (note) => (
                <div key={note.id} className="d-flex mt-1 py-2 border-bottom">
                  <div>
                    <div className="badge bg-light text-dark">
                      {Utils.toLocal(note.created_at).format(
                        "HH:mm MMM DD, YY",
                      )}
                    </div>
                  </div>
                  <div className="text-start text-dark flex-grow-1">
                    {note.note}
                  </div>
                  {(userData.is_super_user ||
                    data.reporting_to == userData.uid) && (
                    <div className="text-end">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/delete.png`}
                        className="clickable text-danger me-1"
                        title={`Delete this note!`}
                        onClick={() => deleteNote(note.id)}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <div className="mt-4">
      {loading && (
        <Alert variant="info" className="p-3">
          <p className="loading-msg">Fetching details..</p>
          <ProgressBar variant="info" animated now={100} />
        </Alert>
      )}
      {!loading && (
        <>
          <Card border="light" className="shadow dashboardStats">
            <Card.Body className="py-0">
              {docSummery()}
              {renderProfile()}
              {docGapSummary()}

              {renderDocTypes()}
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                <a
                  href={
                    Utils.apiUrl("users/exportdata") +
                    "/" +
                    _.get(data, "id", "")
                  }
                >
                  <Button
                    type="submit"
                    variant="primary"
                    className="  shadow-cst p-0 text-light p-2 px-5"
                  >
                    Export Data
                  </Button>
                </a>
              </div>
            </Card.Body>
          </Card>
          {resources && showResources()}
          {upload && showUpload()}
          {trail && showTrail()}
          {msg && showMsg()}
          {udNote !== false && showNotesForUD()}
        </>
      )}
    </div>
  );
};

export default Userprofile;
